import { render, staticRenderFns } from "./DadosComunicacaoTransferencia.vue?vue&type=template&id=0e4f7d9a&scoped=true&"
import script from "./DadosComunicacaoTransferencia.vue?vue&type=script&lang=js&"
export * from "./DadosComunicacaoTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./DadosComunicacaoTransferencia.vue?vue&type=style&index=0&id=0e4f7d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4f7d9a",
  null
  
)

export default component.exports